export const AI_MODERATION_FIELD_IDS = ["intro", "gameName", "serverName", "highlights"] as const;
export type AiModerationField = (typeof AI_MODERATION_FIELD_IDS)[number];

export const AI_MODERATION_FIELD_OPTIONS: ReadonlyArray<{ id: AiModerationField; label: string; description: string }> = [
  { id: "intro", label: "动态正文", description: "用户发布的主要文字内容" },
  { id: "gameName", label: "游戏名称", description: "动态关联的游戏名称" },
  { id: "serverName", label: "游戏区服", description: "用户填写的区服信息" },
  { id: "highlights", label: "内容亮点", description: "动态亮点标签与补充说明" }
];

export const AI_MODERATION_RISK_IDS = [
  "contact_info",
  "off_platform_trade",
  "fraud",
  "hate",
  "sexual",
  "violence",
  "illegal",
  "spam"
] as const;
export type AiModerationRisk = (typeof AI_MODERATION_RISK_IDS)[number];

export const AI_MODERATION_RISK_OPTIONS: ReadonlyArray<{ id: AiModerationRisk; label: string; description: string }> = [
  { id: "contact_info", label: "联系方式", description: "手机号、社交账号或站外引流" },
  { id: "off_platform_trade", label: "私下交易", description: "绕过商城、私下收款或交易诱导" },
  { id: "fraud", label: "欺诈冒充", description: "诈骗、虚假承诺或身份冒充" },
  { id: "hate", label: "仇恨歧视", description: "针对群体的仇恨、侮辱或歧视" },
  { id: "sexual", label: "色情低俗", description: "色情、性暗示或低俗内容" },
  { id: "violence", label: "暴力威胁", description: "暴力描述、人身威胁或伤害煽动" },
  { id: "illegal", label: "违法违禁", description: "违法活动、违禁品或犯罪指导" },
  { id: "spam", label: "垃圾广告", description: "重复灌水、无关推广或明显垃圾内容" }
];

export const DEFAULT_AI_MODERATION_FIELDS: readonly AiModerationField[] = AI_MODERATION_FIELD_IDS;
export const DEFAULT_AI_MODERATION_RISKS: readonly AiModerationRisk[] = AI_MODERATION_RISK_IDS;
